module.exports = __webpack_public_path__ + "media/images/common/ico_02-8b6362727d20c6ef3389a5d0b9092a7f.png";